import { Injectable } from '@angular/core';
import { BehaviorSubject, skip } from 'rxjs';
import { Events } from '../constants/events';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class MapControlService {
  map: google.maps.Map | undefined;
  noshowMarkerList: google.maps.Marker[] = [];
  noshowCircleList:google.maps.Circle[] = [];
  polylineList: google.maps.Polyline[] = [];
  shuttleStopMarkerList: google.maps.Marker[] = [];
  vehicleStoppageMarkerList: google.maps.Marker[] = [];
  sosMarkerList: google.maps.Marker[] = [];
  seatBeltMarkerList: google.maps.Marker[] = [];
  plannedPolylineList: google.maps.Polyline[] = [];
  overSpeedPolylineList: google.maps.Polyline[] = [];
  geofenceCirclesList: google.maps.Circle[] = [];
  infoWindowList: google.maps.InfoWindow[] = [];
  deviceNotConnectedMarkerList: google.maps.Marker[] = [];
  gpsLossPolylineList: google.maps.Polyline[] = [];
  deviceOffPolylineList:google.maps.Polyline[] = [];
  networkLossPolylineList:google.maps.Polyline[] = [];
  noNetworkMarkerList: google.maps.Marker[] = [];
  vehicleArrivedMarkerList: google.maps.Marker[] = [];
  SignInLocationsMarkerList: google.maps.Marker[]=[]
  SignOutLocationsMarkerList:google.maps.Marker[] = []
  CallEmpMarkerList: google.maps.Marker[]=[]

  thresholdSpeed: number = 70;

  startTripBool: boolean = false;
  pauseTripBool: boolean = true;

  playbackSpeed: number = 1;
  tripInterval;
  isSpeedChanged: boolean = false;
  isPaused: boolean = true;

  mapVehicleMarker: google.maps.Marker | undefined | null;

  tripPlayer$: BehaviorSubject<any> = new BehaviorSubject<any>('');

  startCall$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  callForFilterChange$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  tripEndCall$: BehaviorSubject<boolean> = new BehaviorSubject<any>('');
  restartCall$: BehaviorSubject<any> = new BehaviorSubject<any>('');
  callForMapLoader$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  callForPause$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  events: Object[];

  isTripEnded: boolean = false;

  timeoutSet: any[] = [];

  timer: number;
  tripDetails: any;

  eventVisibility: Map<string, boolean> = new Map<string, boolean>();

  constructor(private commonService: CommonService) {
    this.events = Events;
    this.commonService.tripDetailsRes.pipe(skip(1)).subscribe((res) => {
      this.tripDetails = res.tripDetails;
      this.timer = this.tripDetails.actualStartTime;
    });

    // Event visiblity map
    this.events.forEach(evnt => {
      this.eventVisibility.set(evnt['event_icon_add'], evnt['checked']);
    });
  }


  resetVariables(){
    console.log("reset variables");
    this.startTripBool = false;
    this.pauseTripBool = true;
    this.playbackSpeed = 1;
    this.isSpeedChanged = false;
    this.isPaused = true;
    this.isTripEnded = false;
    clearInterval(this.tripInterval);
    this.tripInterval = null;
    this.timeoutSet.forEach(timeout=> clearTimeout(timeout));
    this.timeoutSet = [];
    this.clearMap();
  }

  setMapAtTime(time: number) {
    this.clearMap();
    this.restartCall$.next('');
    const firstLocationTime =this.commonService.locationListRes.getValue()?.[0]?.time;
    if (
      firstLocationTime!=null &&
      firstLocationTime - this.tripDetails.actualStartTime < 0
    ) {
      this.timer=firstLocationTime
    }
    else
    {
      this.timer = this.tripDetails.actualStartTime;
    }
    // 
    this.isTripEnded = false;
    this.callForMapLoader$.next({
      time: time,
      loader: true,
    });
  }

  rad = (x) => (x * Math.PI) / 180;

  getDistance = function (p1, p2) {
    let R = 6378137; // Earth’s mean radius in meter
    let dLat = this.rad(p2.lat() - p1.lat());
    let dLong = this.rad(p2.lng() - p1.lng());
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(p1.lat())) *
        Math.cos(this.rad(p2.lat())) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;
    return d; // returns the distance in meter
  };

  calculateTimer()
  {
    try {
      if(this.commonService.locationListRes?.getValue()[0].time - this.tripDetails.actualStartTime < 0 )
      {
        this.timer=this.commonService.locationListRes.getValue()[0].time
      }
      else{
        this.timer = this.tripDetails.actualStartTime;
      }
    } catch (error) {
      console.log(error)
    }
  }

  clearMap() {
    this.calculateTimer()
    this.polylineList.forEach((poly) => poly.setMap(null));
    this.polylineList = [];
    this.vehicleStoppageMarkerList.forEach((marker) => marker.setMap(null));
    this.vehicleStoppageMarkerList = [];
    this.sosMarkerList.forEach((marker) => marker.setMap(null));
    this.sosMarkerList = [];
    this.overSpeedPolylineList.forEach((marker) => marker.setMap(null));
    this.overSpeedPolylineList = [];
    this.geofenceCirclesList.forEach((marker) => marker.setMap(null));
    this.geofenceCirclesList = [];
    this.mapVehicleMarker?.setMap(null);
    this.mapVehicleMarker = null;
    this.shuttleStopMarkerList.forEach((marker) => marker.setMap(null));
    this.shuttleStopMarkerList = [];
    this.deviceNotConnectedMarkerList.forEach((marker) => marker.setMap(null));
    this.deviceNotConnectedMarkerList = [];
    this.gpsLossPolylineList.forEach((poly) => poly.setMap(null));
    this.gpsLossPolylineList = [];
    this.deviceOffPolylineList.forEach((poly) => poly.setMap(null));
    this.deviceOffPolylineList = [];
    this.networkLossPolylineList.forEach((poly) => poly.setMap(null));
    this.networkLossPolylineList = [];
    this.noNetworkMarkerList.forEach((marker) => marker.setMap(null));
    this.noNetworkMarkerList = [];
    this.vehicleArrivedMarkerList.forEach((marker) => marker.setMap(null));
    this.vehicleArrivedMarkerList = [];
    this.seatBeltMarkerList.forEach((marker) => marker.setMap(null));
    this.seatBeltMarkerList = [];
    this.noshowMarkerList.forEach((marker) => marker.setMap(null));
    this.noshowMarkerList = [];
    this.noshowCircleList.forEach((marker) => marker.setMap(null));
    this.noshowCircleList = [];
    this.SignInLocationsMarkerList.forEach((marker)=>marker.setMap(null) );
    this.SignInLocationsMarkerList=[]
    this.SignOutLocationsMarkerList.forEach((marker)=>marker.setMap(null) );
    this.SignOutLocationsMarkerList=[]
    this.CallEmpMarkerList.forEach((marker)=>marker.setMap(null) );
    this.CallEmpMarkerList=[]
    // this.restartCall$.next('');
  }

  startTrip() {
    if (this.isTripEnded) {
      this.clearMap();
      this.restartCall$.next('');
      // this.isTripEnded = false;
    }
    this.startTripBool = true;
    this.startCall$.next(this.startTripBool);
    this.isPaused = false;
    this.callForPause$.next(this.isPaused);
    this.shuttleStopMarkerList.forEach((marker) =>
      marker.setMap(this.map)
    );
  }

  pauseTrip() {
    clearInterval(this.tripInterval);
    this.startTripBool = false;
    this.pauseTripBool = true;
    this.isPaused = true;
    this.callForPause$.next(true);
    this.timeoutSet.forEach((f) => clearTimeout(f));
  }

  endTrip() {
    this.timer = this.tripDetails.actualStartTime;
    this.isPaused = true;
    this.isTripEnded = true;
    this.tripEndCall$.next(this.isPaused);
  }

  skipForward() {}

  skipBackward() {
    this.pauseTrip();
    this.endTrip();
    this.startTrip();
  }

  changeFilter(eventName: string) {
    const foundEvent = this.events.find(
      (evnt) => evnt['event_icon_add'] === eventName
    );
    foundEvent['checked'] = !foundEvent['checked'];

    this.eventVisibility.set(eventName, foundEvent['checked']);
    
    this.callForFilterChange$.next({
      eventName: eventName,
      isChecked: foundEvent['checked'],
    });
    
    this.changeMap(eventName, foundEvent['checked']);
  }

  setAll(boolean:any) {
    this.events.forEach((event:any)=>{
      event['checked'] = boolean
      const {event_icon_add} = event
      this.eventVisibility.set(event['event_icon_add'], boolean);
      this.callForFilterChange$.next({
        event_icon_add:event_icon_add,
        isChecked: boolean,
      });
      
      this.changeMap(event['event_icon_add'], boolean);
    })
  }

  changeMap(eventName: string, checked: boolean): void {
    switch (eventName) {
      case 'sos': {
        this.sosMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'vehicle-stoppage': {
        this.vehicleStoppageMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'no-network-start': {
        this.networkLossPolylineList.forEach((poly) =>
          poly.setMap(checked ? this.map : null)
        );
        this.noNetworkMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'no-gps': {
        this.gpsLossPolylineList.forEach((poly) =>
          poly.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'over-speeding': {
        this.overSpeedPolylineList.forEach((poly) =>
          poly.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'device-off': {
        this.deviceOffPolylineList.forEach((poly) =>
          poly.setMap(checked ? this.map : null)
        );
        this.deviceNotConnectedMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'planned-route': {
        this.plannedPolylineList.forEach((poly) =>
          poly.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'no-show-events': {
        this.noshowMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        this.noshowCircleList.forEach((marker) => {
          marker.setMap(checked ? this.map : null)
        })
        break;
      }
      case 'signin-employee': {
        this.SignInLocationsMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'signout-employee': {
        this.SignOutLocationsMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'call-emp-events': {
        this.CallEmpMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      } 
      case 'vehicle-arrived': {
        this.vehicleArrivedMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
      case 'seat-belt-worn': {
        this.seatBeltMarkerList.forEach((marker) =>
          marker.setMap(checked ? this.map : null)
        );
        break;
      }
    }
  }

  getFilter(filterName: string) {
    return this.events.find((evnt) => evnt['event_icon_add'] === filterName);
  }
}
